<template>
    <div>
        <div class="bot fake load-img-bot"></div>
        <div class="bot fake load-img-user"></div>

        <div id="minimizedBot-aff" @keyup.enter="toggleBot" @click="toggleBot" >
          <span style="margin-left: 10px;">¿Necesitas ayuda?</span>
          <img id="minimizedBotImg" src="../assets/bot2.png"/>
        </div>
        <div class="bot" id="botWrapper" style="display: none;">
          <div 
            class="bot-header-aff" 
            id="botHeader"
            @keyup.enter="toggleBot"
            @click="toggleBot"
          >
            <div class="bot-header_close" id="botHeaderClose"></div>
          </div>

          <div></div>
          <div class="bot-output" id="botOutputDialog">
            <div class="initial-space"></div>
            <div id="spinner-loader" class="loader"></div>
            <div v-for="message in messages" class="bot-output-dialog_wrapper">
              <div :class="[message.sender=='BOT'?'bot-output-dialog_bot':'bot-output-dialog_user-aff']">
                <span v-html="message.text"></span>
              </div>
            </div>

            <div class="loader-container">
            </div>
          </div>

          <div class="bot-input-aff">
              <div class="bot-input-user_text_wrapper">
                  <div class="bot-input-user_text_input_wrapper">
                    <input 
                      class="bot-input-user_text_input" 
                      id="textToSend" 
                      type="text" 
                      autocomplete="off" 
                      placeholder="Escribe aquí..." 
                      @keyup.enter="sendInputText"
                      v-model="message"
                    />
                  </div>
                  <div class="bot-input-user_text_button_wrapper-aff">
                      <div 
                        class="bot-input-user_text_button" 
                        id="sendTextButton" 
                        @keyup.enter="sendInputText"
                        @click="sendInputText"
                      >
                        <img src="../assets/send-black.png" width="25px" height="25px">
                      </div>
                  </div>
              </div>
          </div>
        </div>
    </div>
</template>

<script>
import firebase from 'firebase';
  export default {
    name: 'ChatbotAfflelou',
    data(){
      return{
        isDialogInit: false,
        waitingForResponse: false,
        url: process.env.VUE_APP_CLOUD_FUNCTIONS_URL, // var entorno 
        message:undefined,
        messages:[], // 1 message = {createdAt, sender, text},
        idSession: null, //solo se usa si no se pueden usar las cookies
        userHideBot: false,
        firstMessage: true
      }
    },
    mounted(){
      this.loginAnon();
        // param getCookie y setCookie --> .env
        let urlParams = new URLSearchParams(window.location.search);
        let minimizedChatBot = urlParams.get('minimizedChatBot');
        let openChatBotms = urlParams.get('openChatBotms')

        //si la cookie dice que el bot esta abierto --> abierto
        /*if(this.getCookie(process.env.VUE_APP_GETCOOKIE_PARAM_AFF) === "false"){
          this.openBot();
        }else */
        if(minimizedChatBot === "false"){
          this.openBot();
        }else{
          this.setCookie(process.env.VUE_APP_GETCOOKIE_PARAM_AFF, 'true');
          this.closeBot();
          let self = this;
          if(openChatBotms !== null && !isNaN(openChatBotms)){
            setTimeout(function(){self.openBotTimeout()}, openChatBotms);
          }
        }

        let self = this;
        window.onfocus = function() {
          //alert('WINDOW FOCUS')
          self.messages = [];
          self.showElementById('spinner-loader');
          self.waitingForResponse = false;
          self.handleInit();

        }

        /*if(this.getCookie(process.env.VUE_APP_GETCOOKIE_PARAM_AFF) === "" || this.getCookie(process.env.VUE_APP_GETCOOKIE_PARAM_AFF) === "false") {
          this.setCookie(process.env.VUE_APP_GETCOOKIE_PARAM_AFF, 'false');
          this.hideElementById('minimizedBot-aff');
          window.top.postMessage('maximize', '*')
          this.showElementById('botWrapper');
          if (!this.isDialogInit) { 
            this.handleInit(); 
            this.isDialogInit = true; 
          }else{
            this.hideElementById('spinner-loader');
          }
        } else {
          this.hideElementById('botWrapper');   
          window.top.postMessage('minimize', '*')
          this.showElementById('minimizedBot-aff');
          this.setCookie(process.env.VUE_APP_GETCOOKIE_PARAM_AFF, 'true');
        }*/
    },
    methods:{
      openBotTimeout(){
        if (this.isElementHiddenById('botWrapper') && this.userHideBot === false) {
          this.hideElementById('minimizedBot-aff');
          window.top.postMessage('maximize', '*')
          this.showElementById('botWrapper');
          if (!this.isDialogInit) { this.handleInit(); this.isDialogInit = true; }
          this.setCookie(process.env.VUE_APP_GETCOOKIE_PARAM_AFF, 'false');
        }
      },
      openBot(){
        this.setCookie(process.env.VUE_APP_GETCOOKIE_PARAM_AFF, 'false');
        this.hideElementById('minimizedBot-aff');
        window.top.postMessage('maximize', '*')
        this.showElementById('botWrapper');
        if (!this.isDialogInit) { 
          this.handleInit(); 
          this.isDialogInit = true; 
        }else{
          this.hideElementById('spinner-loader');
        }
      },
      closeBot(){
        this.hideElementById('botWrapper');        
        window.top.postMessage('minimize', '*')
        this.showElementById('minimizedBot-aff');
        this.setCookie(process.env.VUE_APP_GETCOOKIE_PARAM_AFF, 'true');
      },
      handleInit() {
        if(this.waitingForResponse === false){
          this.waitingForResponse = true;
          fetch(this.url+"events", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              credentials: 'include',
              mode: 'cors',
              body: JSON.stringify({ eventname: process.env.VUE_APP_EVENTNAME_AFF, site: process.env.VUE_APP_SITE_AFF, sessionId: this.idSession }) // site & eventname --> .env
          })
          .then(response => response.json())
          .then(resp =>{
            this.waitingForResponse = false;
            this.hideElementById('spinner-loader');
            this.handleSuccess(resp.resp);
            this.idSession = resp.sessionId;
            if(resp.resp.response && resp.resp.response.length > 0){
              let found = resp.resp.response.find(element => element.sender === 'USER');
              this.firstMessage = !found ? true : false;
            }
          })
          .catch(err => {
            this.waitingForResponse = false;
            console.log(err)
          })
        }
      },
      loginAnon(){
        firebase.auth().signInAnonymously().catch(function(error) {
          // Handle Errors here.
          var errorCode = error.code;
          var errorMessage = error.message;
          // ...
        });
        firebase.auth().onAuthStateChanged(function(user) {
          if (user) {
            //console.log(user);
            // User is signed in.
            var isAnonymous = user.isAnonymous;
            var uid = user.uid;
            //console.log(user.uid);
            // ...
          } else {
            // User is signed out.
            // ...
          }
          // ...
        });
      },
      signoutAnon(){
        firebase.auth.signOut();
      },
      hideElementById(id) {
        document.getElementById(id).style.display = 'none';
      },
      showElementById(id) {
        document.getElementById(id).style.display = 'flex';
      },
      isElementHiddenById(id) {
        return document.getElementById(id).style.display == 'none'
      },
      sendInputText() {
        if(this.message != "" && /\S/.test(this.message) && this.message != undefined){
          this.addDialog(this.message, 'USER', null);
          this.send(this.message);
          if(this.firstMessage){
            this.firstMessage = false;          
            window.top.postMessage({event: process.env.VUE_APP_GMT_FIRSTMESSAGE_EVENTNAME_AFF_PM}, process.env.VUE_APP_AFF_PARENT_PAGE)
            //this.$gtm.trackEvent({
            //  event: process.env.VUE_APP_GMT_FIRSTMESSAGE_EVENTNAME_AFF
            //});
          }
        }
      },
      send(inputText) {
        this.message = ''
        this.disableUserInput(false);

        let uriVars = this.getUriVars();

        console.log( uriVars );


        if(this.waitingForResponse === false){
          this.waitingForResponse = true;  
          fetch(this.url+"query", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              credentials: 'include',
              mode: 'cors',
              body: JSON.stringify({ inputText: inputText, site: process.env.VUE_APP_SITE_AFF, sessionId: this.idSession, utmValues : uriVars }) // site & eventname --> .env
          })
          .then(response => response.json())
          .then(resp =>{
            this.waitingForResponse = false;
            if (resp.resp.response && resp.resp.response.length > 0) {
              this.handleSuccess(resp.resp);
              if(resp.resp.newContext){
                let contextFound = resp.resp.newContext.find(element => element.name.endsWith(process.env.VUE_APP_DIALOGFLOWCONTEXTSTATUSNAME_AFF));
                if(contextFound && contextFound.parameters && contextFound.parameters.fields && contextFound.parameters.fields.state && contextFound.parameters.fields.state.stringValue && contextFound.parameters.fields.state.stringValue === process.env.VUE_APP_DIALOGFLOWSTATUS_APPOINTMENT_AFF){
                  window.top.postMessage({event: process.env.VUE_APP_GMT_APPOINTMENT_EVENTNAME_AFF_PM}, process.env.VUE_APP_AFF_PARENT_PAGE)
                  //this.$gtm.trackEvent({
                  //  event: process.env.VUE_APP_GMT_APPOINTMENT_EVENTNAME_AFF
                  //});
                }
              }
            }else{
              if(inputText.toLowerCase() === process.env.VUE_APP_KW_HANDLEINIT || inputText.toLowerCase() === process.env.VUE_APP_KW_HANDLEINIT2){  // --> .env
                this.handleInit()
              }else{
                let data = {
                  response: [{
                    text:{
                      text: process.env.VUE_APP_MSG_DISCONNECT.replace(/\\n/g, '\n') // --> .env
                    }
                  }],
                  sender : 'BOT'
                }
                this.handleSuccess(data)
              }
            }
            this.idSession = resp.sessionId;
          })
          .catch(err => {
            this.waitingForResponse = false;
            console.log(err)
            if(inputText.toLowerCase() === process.env.VUE_APP_KW_HANDLEINIT || inputText.toLowerCase() === process.env.VUE_APP_KW_HANDLEINIT2){  // --> .env
              this.handleInit()
            }else{
              let data = {
                response: [{
                  text:{
                    text: process.env.VUE_APP_MSG_DISCONNECT.replace(/\\n/g, '\n') // --> .env
                  }
                }],
                sender : 'BOT'
              }
              this.handleSuccess(data)
            }
          })
        }else{
          let data = {
            response: [{
              text:{
                text: process.env.VUE_APP_MSG_WAITING_FOR_RESPONSE.replace(/\\n/g, '\n')  // --> .env
              }
            }],
            sender : 'BOT'
          }
          this.handleSuccess(data)
        }
      },
      getUriVars() {
        let uri = window.location.href.split('?');
        let getVars = {};
        if (uri.length == 2)
        {
          let vars = uri[1].split('&');
          let tmp = '';
          vars.forEach(function(v){
            tmp = v.split('=');
            if(tmp.length == 2)
            getVars[tmp[0]] = tmp[1];
          });
        }
        return getVars;
      },
      handleSuccess(data) {
        this.disableUserInput(false);
        if (data.response && data.response.length > 0) {
          for (let i = 0; data.response.length > i; i++) {
            let sender = (data.sender) ? data.sender : data.response[i].sender
            let banner = (data.banner) ? data.banner : data.response[i].banner
            this.addDialog(data.response[i].text.text, sender, banner);
          }
        }
        if (data.endConversation) {
          this.endChat();
        } else {
          document.getElementById('textToSend').focus();
        }
      },
      urlify(text) {
        //return text;
        var urlRegex = /(https?:\/\/[^\s]+)/g;
        return text.replace(urlRegex, function(url) {
          // If url in french or english, return 'ici' or 'here' (messages EN00 and FR00 in dialogResponse.js)
          if(text.includes('Pour plus')){
            return '<a class="urlLinkBot" target="_blank" href="' + url + '">ici</a>';
          }else if(text.includes('For more information')){
            return '<a class="urlLinkBot" target="_blank" href="' + url + '">here</a>';
          }else if(url.includes('politica-privacidad')){
            // Message '1002' in dialogResponse.js
            return '<a class="urlLinkBot" target="_blank" href="' + url + '">política de privacidad</a>';
          }else if(url.includes('condiciones-generales-de-uso')){
            // Message '1002' in dialogResponse.js
            return '<a class="urlLinkBot" target="_blank" href="' + url + '">condiciones de uso</a>';
          }else{
            return '<a class="urlLinkBot" target="_blank" href="' + url + '">aquí</a>';
          }
        })
      },
      addDialog(msg, sender, banner) {
        console.log(sender + ' -> ' + msg);
        if (msg && sender) {  
          let message = msg;  
          if (sender === 'BOT') {
            let bannerAux = ''
            if(banner){
              bannerAux = '<img style="width: 100%; max-width:100%" @load="scrollToBottomLoadImg" src="'+banner+'"/>'
            }

            if(typeof message === 'string' || message instanceof String){
              // pasarlo  a una lista
              message = [bannerAux + this.urlify(message)];
              console.log(1, message);
            }else{              
              message = message.map(msg =>{return bannerAux + this.urlify(msg)}) 
            }
          }else{
            message = [msg];
          }
          
          message.forEach(msg => {
            let _message = {
              createdAt : new Date(),
              sender : sender, 
              text : msg
            }
            this.messages.push(_message);
          })
          let needScroll = this.needScrollToBottom();
          if(needScroll){
            let self = this;
            this.$nextTick(() => {
              self.scrollToBottom();
            });
          }
        }
      },
      clean() {
        this.disableUserInput(false);
      },
      disableUserInput(booleanValue) {
        document.getElementById("textToSend").disabled = booleanValue;
        document.getElementById("textToSend").disabled = booleanValue;

        if (booleanValue) document.getElementById("sendTextButton").classList.add('bot-input-user_text_button_disabled');
        else document.getElementById("sendTextButton").classList.remove('bot-input-user_text_button_disabled');
      },
      needScrollToBottom(){
        let box = document.querySelector('#botOutputDialog');
        if (box){
          if(box.scrollHeight - box.scrollTop < box.clientHeight + 100){
            return true;
          }
          return false;
        }else{
          return true;
        }
      },
      
      scrollToBottomLoadImg(){
        let self = this
        setTimeout(function(){
          self.scrollToBottom();
        }, 500);
      },
      scrollToBottom(){
            let box = document.querySelector('#botOutputDialog');
            box.scrollTop = box.scrollHeight;   
      },
      toggleBot() {
        if (this.isElementHiddenById('botWrapper')) {
          this.hideElementById('minimizedBot-aff');
          window.top.postMessage('maximize', '*')
          this.showElementById('botWrapper');
          if (!this.isDialogInit) { this.handleInit(); this.isDialogInit = true; }
          this.setCookie(process.env.VUE_APP_GETCOOKIE_PARAM_AFF, 'false');
        } else {
          this.userHideBot = true;
          this.setCookie(process.env.VUE_APP_GETCOOKIE_PARAM_AFF, 'true');
          this.hideElementById('botWrapper');   
          window.top.postMessage('minimize', '*')
          this.showElementById('minimizedBot-aff');
        }
      },
      endChat() {
        /*disableUserInput(true);
        setTimeout(function () {
          toggleBot();
          window.$('.bot-output-dialog_wrapper').remove();
          this.isDialogInit = false;
          disableUserInput(false);
        }, 3000);*/
      },
      setCookie(cname, cvalue) {
        var d = new Date();
        d.setTime(d.getTime() + (20*60*1000));
        var expires = "expires="+ d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/;secure;samesite=none;";
      },
      getCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for(var i = 0; i <ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
          }
        }
        return "";
      },
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .loader-container{
    /* height:100%; */
    width:100%;
  }
  /*======================================*/
  /*===========  MINIMIZED CSS  ==========*/
  /*======================================*/


  #minimizedBot-aff {
      font-family: Gotham,sans-serif;    
      position: fixed;
      bottom: 10px;
      right: 10px;
      width: 165px;
      height: 60px;
      -ms-flex-align: center;
      align-items: center;
      -ms-flex-pack: center;
      justify-content: center;
      padding: 0;
      background-color: #2a2a2a;
      box-shadow: 0 4px 4px 0 rgba(0,0,0,.2);
      border-radius: 50px;
      transition: background-color .2s ease;
      background-color: #c3a269;
      color: #000;
      display: flex;
      display: -webkit-flex;
      font-size: 0.75rem;
      font-weight: 700;
  }

  #minimizedBot-aff:hover {
      color: #000;
      background-color: #fff;
  }

  #minimizedBotImg{
      width: 33px;
      height: 28px;
      margin-right: 8px;
  }

  #minimizedBot:hover .c-tooltips--content {
      font-family: Gotham,sans-serif;
      z-index: 999;
      top: 50%;
      right: 100%;
      display: block;
      margin-top: -15px;
      margin-right: 10px;
      visibility: visible;
      opacity: .8;
  }

  .c-tooltips--content {
      font-family: Gotham,sans-serif;
      position: absolute;
      display: none;
      width: 150px;
      color: #fff;
      background: #000;
      height: 30px;
      line-height: 30px;
      text-align: center;
      visibility: hidden;
      border-radius: 6px;
      font-size: x-small;
  }

  /*======================================*/
  /*===========   CHATBOT CSS   ==========*/
  /*======================================*/
  :root {
      --img-bot:  url('../assets/bot.png');
      --img-user: url('../assets/user.png');
      --img-logo-aff: url('../assets/afflelouLogo.png');
      --img-send: url('../assets/send-black.png');
      --img-new-windows:  url('../assets/new+window-black.png');
      --img-close:  url('../assets/close.png');
  }

  .main {
      width: 100%;
      margin: 0;
      padding: 0;
  }

  body{
      height: 100%;
  }

  /*To load img*/

  .fake {
      display: none;
  }

  .load-img-bot {
      background-image: var(--img-bot);
  }

  .load-img-user {
      background-image: var(--img-user);
  }

  /*Bot*/
  .bot {
      border: none;
      border-bottom: none;
      /*width: 300px;*/
      width: 95%;
      min-width: 250px;
      /*height: 650px;*/
      height: 99%;
      min-height: 250px;
      position: fixed;
      bottom: 0;
      right: 10px;
      margin: 0 0 0 10px;
      /* display: none; */
  }

  .bot * {
      font-family: 'Open Sans', sans-serif;
      font-size: 14px;
      position: relative;
      margin: 0 auto;
  }

  .min-bot {
      height: 55px;
  }

  .hide-element {
      display: none;
  }

  #botWrapper{
    /* border: 1px solid #fc0f42; */
    display: flex;
    display: -webkit-flex;
    flex-direction: column;
    border-radius: 15px 15px 0 0;
    -webkit-box-shadow: 1px 1px 5px 1px rgba(150,150,150,1);
    -moz-box-shadow: 1px 1px 5px 1px rgba(150,150,150,1);
    box-shadow: 1px 1px 5px 1px rgba(150,150,150,1);
    background-color: white;
    border-bottom: 3px solid #c3a269;
  }

  /*Bot Header*/
  .bot-header-aff {
    background-color: #dfcdaf;
    height: 60px;
    /* height: 9vh; */
    border-radius: 15px 15px 0 0;
    text-align: center;
    cursor: pointer;
    background-image: var(--img-logo-aff);
    background-repeat: no-repeat;
    background-position: center;
    background-size: 200px;
    width: 100%;
  }

  .bot-header_close {
      background-image: var(--img-close);
      background-repeat: no-repeat;
      background-position: right;
      background-size: 15px;
      height: 50px;
      width: 90%;
  }


  /*Bot Output*/
  .bot-output {
    /*height: calc(99vh - 135px);
    min-height: calc(250px - 135px);*/
    /* max-height: 250px; */
    /*height: -webkit-calc(100% - 130px);
    height: -moz-calc(100% - 130px);
    height: calc(100% - 130px);*/
    min-height: 250px;
    width: 100%;
    overflow-y: auto;
    background-color: #fff;
    display: -webkit-flex;
    display: flex;
    flex-direction: column;
    /*justify-content: flex-end;*/
    /* bottom: 0; */
    flex-grow: 1;
    /* flex-shrink: 0; */
    margin-top: 10px;
  }

  .bot-output-dialog_wrapper{
    width: 100%;
    /*display: flex;
    display: -webkit-flex;*/
    word-break: break-word;
    margin-bottom: 10px;
  }

  .initial-space{
    /* padding: 10px;
     height: 95vh;*/
     flex: 1 1 auto;  
    }

  .bot-output-dialog_bot{
      /*width: 100%;*/
      padding: 5px 5px 5px 10px;
      margin: 5px 35px 0 15px;
      /* background-size: 30px 30px; */
      /* background-repeat: no-repeat; */
      /* min-height: 30px; */
      white-space: pre-line;
      /* border: 1px solid #eee; */
      background-color: #eee;
      text-align: left;
  }

  .bot-output-dialog_bot::before {
      content: '';
      position: absolute;
      display: inline-block;
      top: 0px;
      left: -10px;
      width: 0px;
      height: 0px;
      border: 5px solid #eee;
      border-left-color: transparent;
      border-bottom-color: transparent;
  }

  .bot-output-dialog_user-aff {
      /*width: 100%;*/
      padding: 5px 10px 5px 5px;
      text-align: right;
      /* background-position: top right; */
      margin: 5px 15px 0 35px !important;
      /* background-size: 30px 30px; */
      /* background-repeat: no-repeat; */
      /* min-height: 30px; */
      color: #fff;
      background-color: #c3a269;
      /* border-top: 1px solid #fc0f42; */
  }

  .bot-output-dialog_user-aff::after {
      content: "";
      position: absolute;
      display: inline-block;
      bottom: 1px;
      right: -10px;
      width: 0px;
      height: 0px;
      border: 5px solid #c3a269;
      border-right-color: transparent;
      border-top-color: transparent;
      box-shadow: 0px 1px #c3a269;
  }

  .bot-output-dialog_bot {
      /* background-image: var(--img-bot); */
  }

  .bot-output-dialog_user-aff {
      /* background-image: var(--img-user); */
  }

  .bot-output-dialog_card_wrapper {
      margin: 0 0;
  }

  .bot-output-dialog_card {
      width: 100%;
      padding: 0 10px;
  }

  .bot-output-dialog_card_button {
      width: 100%;
      border: solid 0.2px;
      border-radius: 2px;
      cursor: pointer;
      box-shadow: 1px 1.5px 2px 1.5px #a6a6a6;
      padding: 10px 3px 10px 0;
      background: var(--img-new-windows) no-repeat 10px 8px;
      background-size: 20px;
  }

  .bot-output-dialog_card_button:hover, .bot-output-dialog_quickReply:hover {
      background-color: #f5f5f5;
  }

  .button-pill {
    background-color: #ddd;
    border: none;
    color: black;
    padding: 10px 20px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    margin: 4px 2px;
    cursor: pointer;
    border-radius: 16px;
  }

  .bot-output-dialog_card_button span {
      padding: 0 10px 0 40px;
  }

  .bot-output-dialog_quickReplies {
      width: 100%;
      text-align: right;
  }

  .bot-output-dialog_quickReply {
      border: solid 0.2px;
      border-radius: 2px;
      cursor: pointer;
      box-shadow: 1px 1.5px 2px 1.5px #a6a6a6;
      padding: 10px 10px;
      background-size: 20px;
      text-align: center;
      text-decoration: none;
      display: inline-block;
      margin: 4px 5px 0px;
      /*border-radius: 16px;*/

  }

  /*Bot Input*/
  .bot-input-aff {
    /*position: absolute;
    bottom: 0;*/
    height: 40px;
    /* height: 5vh; */
    padding-bottom: 5px;
    padding-top: 5px;
    width: 100%;
    /* background-color: #fd6c8b; */
    border-top: 1px solid #c3a269;
    margin-top: 10px; 
  }

  /*Suggestions*/
  .bot-input-suggestion_chip_wrapper {
      display: none;
  }

  .bot-input-suggestion_chip_entry {
      position: relative;
      display: inline-block;
      width: auto;
      margin: 10px 5px auto;
      padding: 2px 5px;
      border: 1px solid #606060;
      background-color: #ffffff;
      vertical-align: middle;
      cursor: pointer;
      border-radius: 12px;
  }

  /*User Text Input*/
  .bot-input-user_text_wrapper {
    height: 40px;
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    padding: 0px 20px 0px 20px;
  }
  .bot-input-user_text_input_wrapper {
      /* display: inline-block;
      position: relative; */
      width: 90%;
  }
  .bot-input-user_text_input {
      height: 40px;
      border: 0;
      padding: 0 10px;
      background-color: transparent;
      border-radius: 20px 0 0 20px;
      width: 90%;
  }
  .bot-input-user_text_input:focus {
      outline: none;
  }
  .bot-input-user_text_button_wrapper-aff {
      
    /* padding-left: 25px;
    display: inline-block;
    position: absolute;
    width: 40px;
    height: 40px; */
    width: 40px;
    height: 40px;
    background: #c3a269;
    border-radius: 50%; 
  }
  .bot-input-user_text_button_wrapper-aff:hover {
    background: #927a51;
  }
  .bot-input-user_text_button {
    cursor: pointer;
    width: 40px;
    height: 40px;
    /* text-align: center; */
    /* background-size: 32px; */
    /* background-image: var(--img-send); */
    /* background-repeat: no-repeat; */
    /* background-position: center; */
    display: flex;
    display: -webkit-flex;
    align-items: center;
    justify-content: center;
      
  }
  .bot-input-user_text_button>img {
      margin-left: 10px;
  }

  .bot-input-user_text_button_disabled {
      cursor: auto;
      opacity: 0.5;
  }

  .urlLinkBot{
      color: #c3a269;
      font-weight: bold;
      text-decoration: none;
  }

  /*SCROLL BAR*/
  ::-webkit-scrollbar {
      width: 8px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
      background: #f1f1f1; 
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
      background: #dfcdaf;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
      background: #927a51; 
  }


  /*SPINNER*/
  .loader {
      border: 16px solid gainsboro; /* Light grey */
      border-top: 16px solid darkgray ; /* Blue */
      border-radius: 50%;
      width: 120px;
      height: 120px;
      animation: spin 2s linear infinite;    
      position: absolute;
      top: 40%;
      left: calc(50vw - 80px);
      z-index: 1;
    }
    
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
</style>